import styled from "styled-components";

export const Container = styled.div`
    height: 10px;
    min-height: 10px;
    width: 100%;
    background: rgb(255,140,47);
    background: linear-gradient(90deg, rgba(255,140,47,1) 25%, rgba(251,50,92,1) 50%, rgba(147,55,237,1) 75%);
`;
